module.exports = "<Checkbox\n  label=\"Coaches\"\n  value=\"Coaches\"\n  isChecked\n/>\n"